export const routes = {
  pathnames: {
    simulator: 'simulator',
    methodology: 'methodology',
    about: 'about',
  }
}